export default __webpack_public_path__ + "static/media/appstore2.be38e86c.svg";